import React, { useContext, useState } from 'react';

import './UserRegistration.css';
import '../../styles/colors.css';
import localize from '../../i18n/localize';
import LocalizedContext from '../../i18n/LocalizedContext';
import UserRegistrationForm from './UserRegistrationForm';

const UserRegistration = props => {
    const language = props.language;

    const lang = useContext(LocalizedContext);

    const [isRegistering, setIsRegistering] = useState(false);

    const registrationForm = isRegistering ? <UserRegistrationForm language={language} /> :
        <div className='UserRegistration-description'>
            <center>
                <span className='UserRegistration-text' onClick={() => setIsRegistering(true)}>{localize(lang, 'userRegistration')}</span>
            </center>
        </div>;


    return (
        <div className='UserRegistration-envelope'>
            <div className='UserRegistration-description'>{localize(lang, 'registrationNeeded')}</div>
            <div className='UserRegistration-description'>{localize(lang, 'lostPassword')}</div>
            {registrationForm}
        </div>
    );
};

export default UserRegistration;